package ru.chm.gradereport.ui.screens.login

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import kotlin.math.roundToInt

/** Height of the native login form (44 + 10 + 44 + 16 + 44 CSS px). */
val NativeLoginFormHeight = 158.dp

/** Hex colors (#RRGGBB) for the native HTML login form. */
data class NativeLoginFormStyle(
    val background: String,
    val border: String,
    val text: String,
    val muted: String,
    val accent: String,
)

/**
 * Real HTML `<form>` with `username` / `current-password` inputs and a submit button.
 *
 * Browser password managers only react to native form controls, so on the web the
 * login screen uses this form instead of Compose text fields: the browser offers to
 * save the password on successful login and autofills credentials on return visits.
 */
@Composable
internal expect fun NativeLoginForm(
    style: NativeLoginFormStyle,
    loading: Boolean,
    submitText: String,
    onSubmit: (login: String, password: String) -> Unit,
    modifier: Modifier = Modifier,
)

internal fun Color.toHexColor(): String {
    fun channel(value: Float): String =
        (value * 255f).roundToInt().coerceIn(0, 255).toString(16).padStart(2, '0')
    return "#${channel(red)}${channel(green)}${channel(blue)}"
}
